<template>
    <el-container>
        <el-header :style="{display: fullscreenFlag ? 'none' : 'block'}">
            <navbar ref="navbar"/>
        </el-header>
        <el-container>
            <el-aside :style="{display: fullscreenFlag ? 'none' : 'block'}">
                <el-scrollbar>
                    <sidebar/>
                </el-scrollbar>
            </el-aside>
            <el-main>
                <div :style="{'min-height': (documentClientHeight) + 'px'}">
                    <main-content v-if="!$store.state.common.contentIsNeedRefresh"/>
                </div>
            </el-main>
        </el-container>
        <!--<el-button class="fullscreen" @click="fullscreen">-->
        <!--<img src="/img/fullscreen.png"/>-->
        <!--</el-button>-->
    </el-container>
</template>

<script>
    import {getUserInfoByToken} from '@/controller/sys'
    import MainContent from './MainContent'
    import Navbar from './Navbar'
    import Sidebar from './Sidebar'
    import screenfull from 'screenfull'

    export default {
        name: 'Layout',
        components: {
            Navbar,
            Sidebar,
            MainContent
        },
        computed: {
            documentClientHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight
                },
                set(val) {
                    this.$store.commit('common/updateDocumentClientHeight', val)
                }
            },
            userId: {
                get() {
                    return this.$store.state.user.id
                },
                set(val) {
                    this.$store.commit('user/updateId', val)
                }
            },
            realName: {
                get() {
                    return this.$store.state.user.name
                },
                set(val) {
                    this.$store.commit('user/updateName', val)
                }
            },
            tenantId: {
                get() {
                    return this.$store.state.tenant.id
                },
                set(val) {
                    this.$store.commit('tenant/updateId', val)
                }
            },
            tenantName: {
                get() {
                    return this.$store.state.tenant.name
                },
                set(val) {
                    this.$store.commit('tenant/updateName', val)
                }
            }
        },
        created() {
            this.getUserInfo()
        },
        mounted() {
            this.resetDocumentClientHeight()
        },
        methods: {
            // 重置窗口可视高度
            resetDocumentClientHeight() {
                this.documentClientHeight = document.documentElement['clientHeight']
                this.$store.commit('common/updateDocumentClientDefaultHeight', this.documentClientHeight)
                window.onresize = () => {
                    this.documentClientHeight = document.documentElement['clientHeight']
                    this.$store.commit('common/updateDocumentClientDefaultHeight', this.documentClientHeight)
                }
            },
            // 获取当前登录人员信息
            getUserInfo() {
                getUserInfoByToken({}).then(data => {
                    if (data && data.code === '00') {
                        this.loading = false
                        this.userId = data.body.user.id
                        this.realName = data.body.user.realName
                        this.$store.commit('user/updateUserInfo', data.body.user)
                        this.$refs.navbar.init(data.body.user.typeId)
                    }
                })
            },
            fullscreen() {
                if (screenfull.isFullscreen) {
                    this.fullscreenFlag = false
                } else {
                    this.fullscreenFlag = true
                }
                screenfull.toggle()
            }
        },
        provide() {
            return {
                // 刷新
                refresh() {
                    this.$store.commit('common/updateContentIsNeedRefresh', true)
                    this.$nextTick(() => {
                        this.$store.commit('common/updateContentIsNeedRefresh', false)
                    })
                }
            }
        },
        data() {
            return {
                fullscreenFlag: false
            }
        }
    }
</script>

<style lang="scss">
    .el-header{
        height: 51px !important;
    }
    .el-header, .el-main {
        padding: 0 !important;
    }

    .el-aside {
        min-width: 200px;
        width: auto !important;

        .el-scrollbar {
            height: 100%;
        }

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-scrollbar__view {
            height: 100%;
        }
        .el-menu-item.is-active {
            border-left: 3px solid #99003a;
            background: linear-gradient(to right, #4899EE 0%, #4899EE 100%) !important;
            font-weight: 600;
        }
        .el-submenu.is-opened {
            .el-submenu__title {
                background: #BFE4F7 !important;
            }

            .el-menu {
                .el-menu-item {
                    background: #BFE4F7 !important;
                }
                .el-menu-item:hover{
                    background: #4899EE !important;
                }

                .el-menu-item.is-active {
                    border-left: 3px solid #99003a;
                    background: linear-gradient(to right, #4899EE 0%, #BFE4F7 100%) !important;
                    font-weight: 600;
                }
            }
        }
    }

    .el-main {
        overflow: hidden !important;
        .el-tabs.main-nav-tabs > .el-tabs__header {
            margin: 0;
            position: fixed;
            top: 51px;
            /*left: 201px;*/
            width: 100%;
            background: #fff;
            z-index: 5;

            .el-tabs__nav-scroll {
                padding-left: 20px;
            }

            .el-tabs__nav {
                padding: 0 10px;

                .el-tabs__active-bar {
                    padding: 0 10px;
                }
            }

            .el-tabs__item.is-active, .el-tabs__item:hover{
                color: #99003a;
                font-weight: 800;
            }
            .el-tabs__active-bar{
                background: #99003a;
            }
        }

        .el-tabs.main-nav-tabs > .el-tabs__content {
            text-align: left;
            margin-top: 40px;

            .main-tabs-tools.el-dropdown {
                position: fixed;
                top: 51px;
                right: 0;
                z-index: 6;
                height: 38px;
                width: 40px;
                line-height: 40px;
                background-color: #f1f4f5;
                cursor: pointer;
                font-size: 16px;
                color: #99003a;
                text-align: center;

                .el-icon--right {
                    margin-left: 0;
                    font-weight: 800;
                }
            }

            .el-tab-pane {
                .el-card {
                    border: none;

                    .content-body {
                        height: 100%;
                    }
                }
            }

            .el-pagination {
                text-align: right;
                margin-top: 10px;
            }
        }
    }

    .fullscreen {
        position: fixed;
        bottom: 50px;
        right: 50px;
        height: 55px;
        z-index: 99;
    }
</style>
